// extracted by mini-css-extract-plugin
export default {"home":"Home_home__82QQc","team":"Home_team__3R26J","image":"Home_image__lbii0","formulario":"Home_formulario__mVy4R"};